import React from 'react';

export const Badge = (props) => {
  const { title, containerClassName, color, tooltip = '' } = props;

  return (
    <span className={`badge badge-${color} ${containerClassName}`}>
      {
        tooltip !== '' && (
          <span className="badge-tooltip">{tooltip}</span>
        )
      }
      {title}
    </span>
  )
}



// WEBPACK FOOTER //
// ./source/client/components/common/badge.jsx